import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import StorageService from "../../util/storage";
import { getOrganisationId } from "../organisations/organisationsSlice";

const client = new ApolloClient({
  uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
  cache: new InMemoryCache(),
  headers: {
    Authorization: `${StorageService.getItem("bearer")}`,
  },
});

export const fetchDocuments = async (userId) => {
  const orgId = await getOrganisationId();

  const query = gql`
  query getDocuments($id: String) {
      documents(filters: { organisation: { orgId: { eq: $id } } }) {
          data {
              id
              attributes {
                  documents(pagination: { limit: 1000 }) {
                      name
                      file {
                          data {
                              attributes {
                                  url
                              }
                          }
                      }
                      categories {
                          data {
                              attributes {
                                  name
                              }
                          }
                      }
                  }
              }
          }
      }
  }
`;
  const { data } = await client.query({
    query,
    variables: { id: orgId },
  });
  return data.documents.data;
};
